export default {
  // general
  'service_settings.update.error':
    'We are unable to update the service at this time. Please try again later.',

  // status checks
  'service_settings.status_checks.list.empty': 'No health checks to display',
  'service_settings.status_checks.gremlin_aws_health_checks.title':
    'Gremlin AWS Health Checks',
  'service_settings.status_checks.gremlin_aws_health_checks.description.part1':
    'Gremlin has the ability to create health checks based on error rates, request rates, and latency for Elastic Load Balancer (ELB) based ',
  'service_settings.status_checks.gremlin_aws_health_checks.description.link.text':
    'AWS services',
  'service_settings.status_checks.gremlin_aws_health_checks.description.part2':
    '. It will take a look at your historical thresholds in the past 15 minutes for this service. Based on these thresholds, Gremlin will be able to determine if your service is passing or failing reliability tests.',
  'service_settings.status_checks.gremlin_aws_health_checks.mapped_elb.label':
    'Mapped ELB: {{elbName}}',
  'service_settings.status_checks.gremlin_aws_health_checks.enable.checkbox.label':
    'Use Gremlin AWS Health Checks for this service',
  'service_settings.status_checks.gremlin_aws_health_checks.save.success.message':
    'Gremlin AWS Health Checks have been {{action}} to this service.',
  'service_settings.status_checks.gremlin_aws_health_checks.save.error.message':
    'There was an error adding Gremlin AWS Health Checks to the service. Please try again later.',
  'service_settings.status_checks.gremlin_aws_health_checks.remove.confirmation.dialog.title':
    'Remove Gremlin AWS Health Checks?',
  'service_settings.status_checks.gremlin_aws_health_checks.remove.confirmation.dialog.body':
    'We will remove all Gremlin AWS Health Checks for this service. If you change your mind later, you can toggle the setting on this page to re-enable it.',

  // AWS Load Balancers drawer and stepper
  'service_settings.aws_load_balancers.drawer.title': 'AWS Integration',
  'service_settings.aws_load_balancers.drawer.stepper.step2': 'Map to ELB',
  'service_settings.aws_load_balancers.drawer.stepper.step3':
    'Enable Gremlin AWS Health Checks',
  'service_settings.aws_load_balancers.drawer.stepper_container.service_update.success':
    'Service updated successfully',
  'service_settings.aws_load_balancers.drawer.stepper_container.service_update.error':
    'There was an error updating the service. Please try again later.',

  // integrations
  'service_settings.integrations.aws_integration.title': 'AWS',
  'service_settings.integrations.aws_integration.has_aws_targets.description.part1':
    'This service is mapped to an AWS ELB. It is eligible for ',
  'service_settings.integrations.aws_integration.has_aws_targets.description.link.text':
    'Gremlin AWS Health Checks',
  'service_settings.integrations.aws_integration.no_aws_targets.description.link.text':
    'Map this service to its Elastic Load Balancer (ELB) to have Gremlin monitor your service’s health during testing with a Gremlin AWS Health Check.',
  'service_settings.integrations.aws_integration.remove.confirmation.dialog.title':
    'Remove AWS Integration?',
  'service_settings.integrations.aws_integration.remove.confirmation.dialog.body':
    'All Gremlin AWS Health Checks will be removed from this service, if enabled.',
  'service_settings.integrations.aws_integration.remove.success':
    'AWS ELB Integration successfully removed',
  'service_settings.integrations.aws_integration.remove.error':
    'An error occurred while removing AWS ELB Integration. Please try again later.',

  // tags
  'service_settings.tags.update.success': 'Service tags successfully updated',
  'service_settings.tags.delete.dialog_title': 'Delete `{{tagName}}`?',
  'service_settings.tags.delete.dialog_body':
    'Are you sure you want to delete tag `{{tagName}}`?',
  'service_settings.tags.description1': 'This service can use custom tags for',
  'service_settings.tags.description2': 'report',
  'service_settings.tags.description3': 'filtering.',
  'service_settings.tags.tag_name.label': 'Tag Name',
  'service_settings.tags.tag_values.label': 'Tag Values',
  'service_settings.tags.tag_values.helper_text':
    "Multiple values are supported: Click value(s) in the dropdown or type a single value or comma-separated values and press 'Enter'.",
  'service_settings.tags.values.label': 'Values',
  'service_settings.tags.new_tag_entry.add_button': 'Add Tag',
  'service_settings.tags.list.empty': 'No tags to display',
  'service_settings.tags.production_environment.checkbox.label.prefix':
    'This Service is in a ',
  'service_settings.tags.production_environment.title':
    'Production Environment',
  'service_settings.tags.production_environment.description':
    'Additional warnings will be shown before any action is taken. This tag can be used to filter reports like custom tags.',

  // tag validation
  'service_settings.tags.new_tag_entry.validation.tag_invalid':
    'Invalid characters. Must begin and end with an alphanumeric character ([a-z0-9A-Z]) with dashes (-), underscores (_), dots (.), and alphanumerics',
  'service_settings.tags.new_tag_entry.validation.tag_name_required':
    'Tag Name is required',
  'service_settings.tags.new_tag_entry.validation.tag_name_exists':
    'Tag with that name is already saved',
  'service_settings.tags.new_tag_entry.validation.tag_value_required':
    'At least one tag value is required'
}
